import createRemoteArrayResourceReducer from "./helpers/createRemoteArrayResourceReducer";

export const bucketsList = createRemoteArrayResourceReducer("BUCKETS_LIST");
export const bucketFolders = createRemoteArrayResourceReducer("BUCKET_FOLDERS");
export const dateFolderContents = createRemoteArrayResourceReducer(
  "DATE_FOLDER_CONTENTS"
);
export const performanceFolderContents = createRemoteArrayResourceReducer(
  "PERFORMANCE_FOLDER_CONTENTS"
);
export const rh20kmidContents = createRemoteArrayResourceReducer(
  "RH20KMID_CONTENTS"
);
export const downloadFile = createRemoteArrayResourceReducer("DOWNLOAD_FILE");
